/**
 * @generated SignedSource<<e417a04f928cb3b15e7374bb8a5a12af>>
 * @relayHash 54e21ba542c006df4ad37811762f5d1d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 5702d90d75c84173ac9a4bbb4a4741c92b8521f00c130f540b5a9adab2bef6ee

import type { ConcreteRequest, Query } from 'relay-runtime';
export type ConfluenceEdition = "FREE" | "PREMIUM" | "STANDARD" | "%future added value";
export type GrowthUnifiedProfileTrialType = "AUTO_UPGRADE" | "DIRECT_TRIAL" | "MANUAL_TRIAL" | "REVERSE_TRIAL" | "%future added value";
export type useOnAttemptToUpgradeQuery$variables = {
  entitlementId: string;
  shouldCheckForCustomerUpgrade: boolean;
};
export type useOnAttemptToUpgradeQuery$data = {
  readonly confluence_tenantContext: {
    readonly editions: {
      readonly confluence: ConfluenceEdition;
    };
  } | null | undefined;
  readonly growthUnifiedProfile_getEntitlementProfile?: {
    readonly lastKnownTrial: {
      readonly trialEndTimeStamp: number | null | undefined;
      readonly trialType: GrowthUnifiedProfileTrialType | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type useOnAttemptToUpgradeQuery = {
  response: useOnAttemptToUpgradeQuery$data;
  variables: useOnAttemptToUpgradeQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "entitlementId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "shouldCheckForCustomerUpgrade"
  }
],
v1 = [
  {
    "concreteType": "ConfluenceTenantContext",
    "kind": "LinkedField",
    "name": "confluence_tenantContext",
    "plural": false,
    "selections": [
      {
        "concreteType": "Editions",
        "kind": "LinkedField",
        "name": "editions",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "confluence"
          }
        ]
      }
    ]
  },
  {
    "condition": "shouldCheckForCustomerUpgrade",
    "kind": "Condition",
    "passingValue": true,
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "entitlementId",
            "variableName": "entitlementId"
          }
        ],
        "concreteType": "GrowthUnifiedProfileEntitlementProfileResult",
        "kind": "LinkedField",
        "name": "growthUnifiedProfile_getEntitlementProfile",
        "plural": false,
        "selections": [
          {
            "concreteType": "GrowthUnifiedProfileEntitlementContextTrialResult",
            "kind": "LinkedField",
            "name": "lastKnownTrial",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "trialEndTimeStamp"
              },
              {
                "kind": "ScalarField",
                "name": "trialType"
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useOnAttemptToUpgradeQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useOnAttemptToUpgradeQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "5702d90d75c84173ac9a4bbb4a4741c92b8521f00c130f540b5a9adab2bef6ee",
    "metadata": {},
    "name": "useOnAttemptToUpgradeQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "3e50b7e4db2a6629e837fcef8e8d2fef";

export default node;
